

























































































































































import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import {
  apiSalarySettlementLists,
  apiSalarySettlementConfirm,
  apiSalarySettlementPay,
  apiSalarySettlementGenerate
} from '@/api/staff'

@Component
export default class SalarySettlementList extends Vue {
    queryObj: any = {
      settlement_period: '',
      keyword: '',
      settlement_status: '',
      payment_status: ''
    }

    tableData: any[] = []
    loading = false
    selectedRows: any[] = []

    pager = new RequestPaging()

    getList (page?: number): void {
      page && (this.pager.page = page)
      this.loading = true

      this.pager
        .request({
          callback: apiSalarySettlementLists,
          params: {
            ...this.queryObj
          }
        })
        .then((res: any) => {
          this.tableData = res.lists || []
        })
        .finally(() => {
          this.loading = false
        })
    }

    handleReset () {
      this.queryObj = {
        settlement_period: '',
        keyword: '',
        settlement_status: '',
        payment_status: ''
      }
      this.getList(1)
    }

    handleGenerate () {
      this.$confirm(
        '将自动汇总所有已完成且尚未结算的工单，为每位相关师傅生成结算单，是否继续？',
        '生成结算',
        { type: 'warning' }
      ).then(() => {
        const loading = this.$loading({ lock: true, text: '正在生成结算单...' })
        apiSalarySettlementGenerate({})
          .then((res: any) => {
            const data = res || {}
            const success = data.success ?? 0
            const fail = data.fail ?? 0
            if (success > 0) {
              this.queryObj.settlement_period = ''
              this.getList(1)
            }
          })
          .finally(() => {
            loading.close()
          })
      }).catch(() => {
        // 用户取消
      })
    }

    handleBatchPay () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要支付的结算单')
        return
      }

      const canPay = this.selectedRows.every(row => this.canPaySettlement(row))

      if (!canPay) {
        this.$message.warning('只能支付「已确认」且「待支付」的结算单')
        return
      }

      this.$confirm(`确定要批量支付选中的 ${this.selectedRows.length} 个结算单吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({ lock: true, text: '支付中...' })
        Promise.all(
          this.selectedRows.map(row =>
            apiSalarySettlementPay({ id: row.id, payment_status: 2 })
          )
        )
          .then(() => {
            this.getList()
          })
          .finally(() => {
            loading.close()
          })
      })
    }

    handleView (row: any) {
      this.$router.push({ path: '/staff/salary-settlement/detail', query: { id: row.id } })
    }

    handleConfirm (row: any) {
      this.$confirm('确定要确认该结算单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        apiSalarySettlementConfirm({ id: row.id }).then(() => {
          this.getList()
        })
      })
    }

    canPaySettlement (row: any): boolean {
      return [2, 3].includes(row.settlement_status) && row.payment_status === 1
    }

    handlePay (row: any) {
      this.$confirm(
        `确定要支付该结算单吗？实发金额：${this.formatCurrency(row.net_salary)}。支付后将计入师傅可提现余额。`,
        '提示',
        { type: 'warning' }
      ).then(() => {
        apiSalarySettlementPay({ id: row.id, payment_status: 2 }).then(() => {
          this.getList()
        })
      })
    }

    handleSelectionChange (val: any[]) {
      this.selectedRows = val
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.getList()
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.getList()
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    formatDate (timestamp: number): string {
      if (!timestamp) {
        return '-'
      }
      const date = new Date(timestamp * 1000)
      return `${date.getMonth() + 1}月${date.getDate()}日`
    }

    getSettlementStatusText (status: number): string {
      const statusMap = ['', '待确认', '已确认', '已审核', '已驳回']
      return statusMap[status] || '未知'
    }

    getSettlementStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'info', 'success', 'danger']
      return typeMap[status] || ''
    }

    getPaymentStatusText (status: number): string {
      const statusMap = ['', '待支付', '已支付', '支付失败']
      return statusMap[status] || '未知'
    }

    getPaymentStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'success', 'danger']
      return typeMap[status] || ''
    }

    created () {
      // 默认查询当前月份的结算
      const now = new Date()
      this.queryObj.settlement_period = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}`

      this.getList()
    }
}
